import moment from "moment";

export const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};

export const TimeFormatter = (timestamp) => {
  let t = new Date(timestamp);
  const formatDateTime = (dateString) =>
    moment(dateString).format("MM-DD-YYYY, hh:mm:ss A");
  return <div>{formatDateTime(t)}</div>;
};

// utils/dateFormatter.js
export const formatDateRange = (startDate, endDate) => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}-${month}-${year}`;
  };

  if (!startDate || !endDate) return "";

  return `${formatDate(startDate)} - ${formatDate(endDate)}`;
};
